<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: yd
 * @LastEditTime: 2020-10-19 14:14:04
--> 
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-logic-configuration')"
                       :show_del="hasBtn('delete-logic-configuration')"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <codeLogic :readonly='readonly'
               @changeReadonly='handleEdit'></codeLogic>
  </div>
</template>

<script>
import {
  getCodeLogicList, addCodeLogic
  , detailCodeLogic, updateCodeLogic, deleteCodeLogic
} from '@/service/api/codeLogic.js'
import codeLogic from './modules/codeLogic'
export default {
  components: {
    codeLogic
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {
  },
  created () { },
  watch: {},
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {
  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteCodeLogic({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code === '200') {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'codeLogic',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
